import { Link } from 'react-router-dom'

export function SiteFooter() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/favicon-server.svg" 
                alt="OpenApps Logo" 
                className="w-8 h-8"
              />
              <span className="text-xl font-bold">OpenApps</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              The secure connective layer that unlocks the internet for AI agents—enabling them to act safely 
              in the real world. Built for developers, trusted by enterprises.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://x.com/openapps_ai" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">Twitter/X</a>
              <a href="https://www.linkedin.com/company/openapps-ai" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">LinkedIn</a>
              <a href="https://github.com/openapps-ai" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">GitHub</a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#features" className="hover:text-white transition-colors">Features</a></li>
              <li><a href="#pricing" className="hover:text-white transition-colors">Pricing</a></li>
              <li><a href="#docs" className="hover:text-white transition-colors">Documentation</a></li>
              <li><a href="#api" className="hover:text-white transition-colors">API Reference</a></li>
              <li><a href="#changelog" className="hover:text-white transition-colors">Changelog</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/press" className="hover:text-white transition-colors">Press</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors">Partners</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/help" className="hover:text-white transition-colors">Help Center</Link></li>
              <li><Link to="/community" className="hover:text-white transition-colors">Community</Link></li>
              <li><a href="https://status.openapps.ai" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Status</a></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/security" className="hover:text-white transition-colors">Security</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-400 text-sm">© {new Date().getFullYear()} OpenApps. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Service</Link>
            <Link to="/cookies" className="text-gray-400 hover:text-white text-sm transition-colors">Cookie Policy</Link>
          </div>
          <form className="w-full md:w-auto flex items-center gap-2">
            <input
              type="email"
              placeholder="Subscribe to updates"
              className="w-full md:w-64 px-3 py-2 rounded-md bg-gray-800 text-gray-200 placeholder-gray-500 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            <button type="button" className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm">Subscribe</button>
          </form>
        </div>
      </div>
    </footer>
  )
}


